import { useReducedMotion } from '../hooks/useReducedMotion';

export const Spinner = ({ size = 20, className = '' }) => {
    const prefersReduced = useReducedMotion();
    return (
        <div
            className={`rounded-[20px] border-2 border-gray-200 border-t-emerald-500 shrink-0 ${prefersReduced ? '' : 'animate-spin'} ${className}`}
            style={{ width: size, height: size }}
            role="status"
            aria-label="Loading"
        />
    );
};
